import script from "./AllProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProduct.vue?vue&type=script&setup=true&lang=js"

import "./AllProduct.vue?vue&type=style&index=0&id=8b82767e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b82767e"]])

export default __exports__